import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { API, environment } from "src/environments/environment";
import { maskCPF, maskTelefoneCelular } from "src/environments/environment";
import { UserService } from "src/app/services/user.service";
import { AjaxService } from "src/app/service/ajax.service";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { UtilService } from "src/app/service/util.service";

@Component({
  selector: "app-perfil-cliente",
  templateUrl: "./perfil-cliente.component.html",
  styleUrls: ["./perfil-cliente.component.scss"],
})
export class PerfilClienteComponent implements OnInit {
  perfilForm: FormGroup;
  senhaForm: FormGroup;
  loading = false;
  isSubmitting = false;
  isSubmittingSenha = false;
  successMessage = "";
  errorMessage = "";
  senhaSuccessMessage = "";
  senhaErrorMessage = "";
  cpfMask = maskCPF;
  telefoneMask = maskTelefoneCelular;
  user: any;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private auth: UserService,
    private ajaxService: AjaxService,
    private util: UtilService
  ) {
    this.perfilForm = this.fb.group({
      NOME: ["", Validators.required],
      CPF: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/),
        ],
      ],
      EMAIL: ["", [Validators.required, Validators.email]],
      TELEFONE: ["", Validators.required],
      ENDERECO: ["", Validators.required],
    });

    this.senhaForm = this.fb.group(
      {
        senhaAtual: ["", Validators.required],
        novaSenha: ["", [Validators.required, Validators.minLength(6)]],
        confirmarSenha: ["", Validators.required],
      },
      { validator: this.senhasIguais }
    );
  }

  ngOnInit(): void {
    this.user = this.auth.getUser();
    this.carregarDados();
  }

  carregarDados(): void {
    this.loading = true;
    this.ajaxService
      .get(`${API}UsuarioCliente/UsuarioCliente?ID_USUARIO=${this.user.Id}`)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.perfilForm.patchValue({
              NOME: response.data[0].nome,
              CPF: response.data[0].cpf,
              EMAIL: response.data[0].email,
              TELEFONE: response.data[0].telefone,
              ENDERECO: response.data[0].endereco,
            });
          }
        },
        error: (error) => {
          this.errorMessage =
            "Erro ao carregar dados do perfil. Tente novamente.";
          console.error("Erro ao carregar dados:", error);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  onSubmit(): void {
    if (this.perfilForm.invalid) return;

    this.util.showLoading();
    //let dados = this.perfilForm.value;
    let dados = this.getDados();

    this.ajaxService
      .post(`${API}UsuarioCliente/UsuarioCliente`, dados)
      .subscribe({
        next: () => {
          this.successMessage = "Perfil atualizado com sucesso!";
          this.errorMessage = "";
        },
        error: (error) => {
          this.util.closeLoading();
          this.errorMessage = "Erro ao atualizar perfil. Tente novamente.";
          this.successMessage = "";
          console.error("Erro ao atualizar:", error);
        },
        complete: () => {
          this.util.closeLoading();
        },
      });
  }
  getDados() {
    return {
      NOME: this.perfilForm.value.NOME,
      CPF: this.perfilForm.value.CPF,
      EMAIL: this.perfilForm.value.EMAIL,
      TELEFONE: this.perfilForm.value.TELEFONE,
      ENDERECO: this.perfilForm.value.ENDERECO,
      ID_USUARIO: this.user.Id,
    };
  }

  onSubmitSenha(): void {
    if (this.senhaForm.valid) {
      debugger;
      var dados = {
        LOGIN: this.perfilForm.value.EMAIL,
        SENHA: this.senhaForm.value.senhaAtual,
        NOVA_SENHA: this.senhaForm.value.novaSenha,
        CONFIRMACAO_SENHA: this.senhaForm.value.confirmarSenha,
        ID_USUARIO: this.user.Id,
      };

      this.util.showLoading();
      this.ajaxService
        .post(`${API}Usuario/Usuario/AlterarSenha`, dados)
        .subscribe({
          next: () => {
            this.senhaSuccessMessage = "Senha alterada com sucesso!";
            this.senhaForm.reset();
            this.util.closeLoading();
          },
          error: (error) => {
            this.senhaErrorMessage = error.error.message;
            this.util.closeLoading();
          },
        });
    }
  }

  senhasIguais(group: FormGroup) {
    const senha = group.get("novaSenha")?.value;
    const confirmarSenha = group.get("confirmarSenha")?.value;
    return senha === confirmarSenha ? null : { senhasDiferentes: true };
  }
}
